import React from 'react';
export const ComparisonSection = () => {
  const rows = [{
    without: 'Buscar actividades diferentes cada día y depender de información suelta.',
    with: 'Más de 300 actividades físicas y cognitivas reunidas en un solo sistema.'
  }, {
    without: 'No saber qué propuesta se ajusta mejor a cada momento.',
    with: 'Tres niveles de adaptación para elegir un punto de partida adecuado.'
  }, {
    without: 'Tener registros desorganizados entre papeles y notas.',
    with: 'Bitácoras listas para completar y compartir en las consultas.'
  }, {
    without: 'Sentir que toda la organización del cuidado recae sobre una sola persona.',
    with: 'Herramientas para distribuir tareas, rutinas y participación familiar.'
  }, {
    without: 'Improvisar cómo acompañar el movimiento y las actividades cotidianas.',
    with: 'Rutinas físicas y cognitivas organizadas, imprimibles y reutilizables.'
  }];
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-42">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-43">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold text-center mb-8 md:mb-16 leading-tight" data-id="element-44">
          ¿Cuánto cuesta no tener <br className="hidden md:block" data-id="element-45" /> Vitalidad
          360™?
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-46">
          {rows.map((row, i) => <div key={i} className="bg-familia-section border border-familia-green/25 p-4 md:p-6 rounded-2xl flex items-start gap-3 md:gap-4" data-id="element-47">
              <span className="text-familia-green text-xl shrink-0" data-id="element-48">✅</span>
              <p className="text-white/90 text-[15px] md:text-base leading-relaxed" data-id="element-49">
                <span className="text-familia-red font-bold block mb-1" data-id="element-50">
                  SIN UN SISTEMA: {row.without}
                </span>
                <span className="text-familia-cyan font-bold block" data-id="element-51">
                  CON VITALIDAD 360™: {row.with}
                </span>
              </p>
            </div>)}
        </div>
        <div className="mt-12 md:mt-24 text-center" data-id="element-52">
          <h3 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-4 leading-tight" data-id="element-53">
            Puedes seguir buscando ideas sueltas cada vez que las necesitas,
            <br className="hidden md:block" data-id="element-54" /> o acceder hoy a un sistema
            organizado y comenzar con una primera rutina adaptada.
          </h3>
          <p className="text-familia-gray text-[15px] md:text-xl" data-id="element-55">
            Más claridad para acompañar, organizar y compartir el cuidado.
          </p>
        </div>
      </div>
    </section>;
};